<script setup>
import IconArrow08 from '@/components/svg/IconArrow08.vue';

import { useAnalysisStore } from '@/store/modules/analysis';
import { addContentLogAPI } from '@/api/logServiceApi';
import { CONTENTS } from './constants';

const analysisStore = useAnalysisStore();

/** 목차 클릭시 이동 */
const goToSummarySection = (contentIdx) => {
  // 목차 클릭 (사주풀이는 무료 전용이라 free). 신규 type — DB 등록 후 작동
  addContentLogAPI({
    contentType: 'as_summary_toc_free_opt3',
    option3: String(contentIdx + 1),
  });
  analysisStore.navigateToContent('/summary', contentIdx);
};
</script>

<template>
  <div class="si-overview si-overview--saju">
    <!-- 표지 -->
    <div class="si-overview__cover">
      <div class="si-overview__cover-inner">
        <div class="si-overview__header">
          <div class="si-overview__title">
            <div class="si-overview__name">
              <span class="si-overview__name-text">{{ analysisStore.userName || '-' }}</span>
              <span class="si-overview__name-suffix">님의</span>
            </div>
            <div class="si-overview__service">사주풀이</div>
          </div>
          <div class="si-overview__badge">
            <span class="si-overview__badge-tag">이벤트 - 무료</span>
          </div>
        </div>
        <div class="si-overview__img">
          <img src="@manseImages/saju-summary-cover.png" alt="saju-summary-img" />
        </div>
      </div>
    </div>
    <!-- 목차 -->
    <div class="si-overview__toc">
      <div class="si-overview__toc-title">목차</div>
      <div class="si-overview__toc-list">
        <button
          v-for="(item, idx) in CONTENTS"
          :key="idx"
          class="si-overview__toc-item"
          @click="goToSummarySection(idx)"
        >
          <div class="si-overview__toc-label">
            {{ item.title }}
            <div
              v-if="idx === 2 || idx === 7 || idx === 8"
              class="si-overview__toc-badge si-overview__toc-badge--new"
            >
              NEW
            </div>
          </div>
          <div class="si-overview__toc-icon">
            <IconArrow08 />
          </div>
        </button>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
@import '@/assets/nangman_style/_saju-insight-overview.scss';
</style>
